/* unplugin-vue-components disabled */import { render } from "./EditVideoChapter.vue?vue&type=template&id=5e111332&scoped=true&ts=true"
import script from "./EditVideoChapter.vue?vue&type=script&lang=ts"
export * from "./EditVideoChapter.vue?vue&type=script&lang=ts"

import "./EditVideoChapter.vue?vue&type=style&index=0&id=5e111332&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e111332"]])

export default __exports__